import { useState } from 'react';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
// Hook to track viewport height on mobile devices (accounts for browser URL bar show/hide)
export const useViewportHeight = () => {
    const [viewportHeight, setViewportHeight] = useState(
        typeof window !== 'undefined' ? window.innerHeight : 0
    );

    useEffectWithErrorLogging(() => {
        const handleResize = () => {
            setViewportHeight(window.innerHeight);
        };

        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleResize);
        };
    }, []);

    return viewportHeight;
};
